module.exports = __webpack_public_path__ + "img/FR12739.136ccc61.png";